export enum DEALER_TYPE {
	VN = 1, // sales
	PS = 2, // service
	AG = 4, // sales agent
	VO = 10, // sales vo
}

// DEALER_TYPE_CODE[n] devuelve el nodo de DEALER_TYPE cuyo valor es n, o undefined si no existe
export const DEALER_TYPE_CODE = Object.entries(DEALER_TYPE)
	.filter(([key]) => isNaN(Number(key))) // solo nombres del enum
	.reduce<(string | null)[]>((acc, [key, value]) => {
		acc[value as number] = key;
		return acc;
	}, []);
